module.exports = __webpack_public_path__ + "img/feedback-success.be04e5ee.png";